import { API_KEYWORD_SEPARATOR, client } from '@/api/backoffice-api';
import AppConfig from "@/utils/app-config.mjs";
import { IServerSideDatasource, IServerSideGetRowsParams, SortModelItem } from "ag-grid-community";
import SortModelMap from '@/utils/grid/datasource/SortModelMap';
import FilterModelMap from '@/utils/grid/datasource/FilterModelMap';
import logger from '@/utils/logger.mjs';

const multiValueSeparator = ';';

export default class StoresDataSource implements IServerSideDatasource {
  /**
   * Converts an agGrid request to an API request
   * @param params the IServerSideGetRowsRequest get rows request
   */
  async fetchData(sortModel: any, filterModel:any) {
    const sortModelType = this.mapSortModel(sortModel)
    // const filter = {is_external:JSON.stringify(filterModel.is_external.values)}
    const params = {
      orderBy: sortModelType && sortModelType.length > 0 ?sortModelType[0]?sortModelType: JSON.stringify([]): JSON.stringify([]),
      'filter[]': this.mapFilterModel(filterModel).join(),
    };
    const response = await client.get(
      `${AppConfig.backOfficeApiBaseURL}/admin/stores`,
      { params }
    );
    return response.data;
  }

  /**
   * Get rows from the API
   * @param params
   */
  getRows(params: IServerSideGetRowsParams): void {
    const { request } = params;
    const { filterModel }:any = request;
     // Extract store type filter
     let storeTypeFilter = undefined;
     if (filterModel?.is_external && filterModel?.is_external.values) {
       storeTypeFilter = filterModel.is_external.values.map((value:string) => value === "Live");
     }
    this.fetchData(params.request.sortModel, filterModel)
      .then((result: any) => {
        const rows = result.items || result;
        const total = result.meta?.resultCount || rows.length;
        params.success({
          rowData: rows,
          rowCount: total
        });
      })
      .catch((error) => {
        console.error('Error while fetching rows for ag-Grid', error);
        params.fail();
      });
  }

  
    /**
   * Map the filter model to a filter property and value
   * @param filterModel the ag-grid FilterModel object
   * @private
   */
    mapFilterModel(filterModel: FilterModel): string[] {
      const filterProps = Object.entries(filterModel);
      const filters: string[] = [];
      filterProps.map(([key, value]) => {
        const field = FilterModelMap.get(key) || key;
        let op;
        let val;
        switch (value.filterType) {
          
          case 'set': {
            op = 'inSet';
            val = value.values.join(multiValueSeparator);
            break;
          }
          
          default: {
            logger.error(
              `No mapFilterModel handler for filter type ${value.filterType}`
            );
          }
        }
        if (val) filters.push([field, op, val].join(API_KEYWORD_SEPARATOR));
      });
      return filters;
    }


  /**
 * Map the agGrid sort model to our API sort model
 * @param sortModel
 * @private
 */
  mapSortModel(sortModel: SortModelItem[]): string[] {
    return sortModel.map((s) => {
      // we process 'age' differently
      if (s.colId === 'age') {
        return ['store_name', s.sort === 'asc' ? 'desc' : 'asc'].join(
          API_KEYWORD_SEPARATOR
        );
      }

      const field = SortModelMap.get(s.colId) || s.colId;
      return [field, s.sort].join(API_KEYWORD_SEPARATOR);
    });
  }
}

interface FilterModel {
  values: unknown[];
  filterType: string;
}